import { render, staticRenderFns } from "./BayesianCompetition.vue?vue&type=template&id=0b12aec2&scoped=true"
import script from "./BayesianCompetition.vue?vue&type=script&lang=js"
export * from "./BayesianCompetition.vue?vue&type=script&lang=js"
import style0 from "./BayesianCompetition.vue?vue&type=style&index=0&id=0b12aec2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b12aec2",
  null
  
)

export default component.exports